// Klarna with adyen supported countries: https://docs.adyen.com/payment-methods/klarna/#supported-countries

const countryListAvailableForKlarna = [
    { value: 'AU', currency: 'AUD' },
    { value: 'AT', currency: 'EUR' },
    { value: 'CA', currency: 'CAD' },
    { value: 'CZ', currency: 'CZK' },
    { value: 'FI', currency: 'EUR' },
    { value: 'FR', currency: 'EUR' },
    { value: 'DE', currency: 'EUR' },
    { value: 'GR', currency: 'EUR' },
    { value: 'IE', currency: 'EUR' },
    { value: 'IT', currency: 'EUR' },
    { value: 'NO', currency: 'NOK' },
    { value: 'PT', currency: 'EUR' },
    { value: 'RO', currency: 'RON' },
    { value: 'ES', currency: 'EUR' },
    { value: 'SE', currency: 'EUR' },
    { value: 'NL', currency: 'EUR' },
    { value: 'GB', currency: 'GBP' },
    { value: 'US', currency: 'USD' },
];

export default countryListAvailableForKlarna;
